import Config from '../Config/Config';

export function getPageLanguage(fallback: string = Config.get('app.locale')): string {
    return document.documentElement.lang || fallback;
}

export function getNormalizedPageLanguage(fallback: string = Config.get('app.locale')): string {
    return getPageLanguage(fallback).toLowerCase().replace('_', '-');
}
